import React, { useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import '../../modalright.css';
import '../../popup.css';
import axios from 'axios';
import jQuery from 'jquery';
import { useNavigate } from 'react-router-dom';
import { getDriverApiBaseUrl } from '../../utils/utils';

export default function DriverConfig() {
    const API_URL = getDriverApiBaseUrl();
    const $ = jQuery.noConflict();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [drivers, setDrivers] = useState([]);  // State for fetched drivers
    const [selectedConfig, setSelectedConfig] = useState(""); // Track the selected config
    const [vehicleCount, setVehicleCount] = useState(0);
    const [newConfigName, setnewConfigName] = useState('');
    const [vehicleModels, setVehicleModels] = useState([]);
    const [configurations, setConfigurations] = useState([]); // State for configurations
    const [configurations2, setConfigurations2] = useState([]); // State for configurations
    const [isDriverLoading, setIsDriverLoading] = useState(true); // Loading state for drivers


    useEffect(() => {
        
        fetchConfigurations();
    }, []);
    
    const fetchConfigurations = async () => {
        try {
            const response = await axios.get(`${API_URL}shypvdriverapp/configure/getConfigs`);
            if (response.data.success) {
                setConfigurations2(response.data.data); // Set the configurations list

                const lastConfig = response.data.data[response.data.data.length - 1];
                // handleConfigChange({ target: { value: lastConfig.configuration_id } }); // Call handleConfigChange to load detai
                
            }
        } catch (error) {
            console.error('Error fetching configurations:', error);
        } finally {
            setLoading(false);
        }
    };

    const buttonsyle={
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        marginRight: '10px',
        borderColor:'#00a6ed',
        cursor:'pointer'
    }
    // Static Data for Configurations (Simulate existing configurations with varying vehicle counts and drivers)
   

    useEffect(() => {
        // Fetch drivers from the API on component mount
        fetchDrivers();
    }, []);

    // Fetch Drivers API call
    const fetchDrivers = async () => {
        const emirate = sessionStorage.getItem('selectedEmirate').toLowerCase(); 
        const API_PATH = `${API_URL}shypvdriverapp/driver/getDriverByEmirates?emirate=${emirate}`;

        try {
            const response = await axios.get(API_PATH);
            if (response.data.success) {
                setDrivers(response.data.data.drivers); // Set the drivers data
            } else {
                console.error('Error fetching drivers data');
            }
        } catch (error) {
            console.error('Error occurred while fetching drivers', error);
        } finally {
            setIsDriverLoading(false); // Set loading to false once data is fetched
        }
    };

  

    const handleConfigChange = async (event) => {
        setnewconfiguration(false)
        const selectedConfigId = event.target.value;
        setSelectedConfig(selectedConfigId);  // Set the selected config ID
    
        if (!selectedConfigId) {
            setConfigurations([]);  // Clear configurations if no config is selected
            return;
        }
    
        // API call to fetch the configuration details
        try {
            const response = await axios.get(`${API_URL}shypvdriverapp/configure/getConfig?id=${selectedConfigId}`);
    
            if (response.data.success) {
                const configData = response.data.data;  // The data object contains drivers and vehicle count
                const drivers = configData.drivers || [];  // List of drivers
                const vehicleCount = configData.vehicle_count || 0;
    
                // Create an array of vehicles for the selected config, initially with empty driverId and driverName
                const vehicles = Array.from({ length: vehicleCount }, (_, index) => {
                    const driver = drivers[index] || {};  // Assign driver if available, else leave empty
                    return {
                        id: index + 1,
                        vehicle: `Vehicle ${index + 1}`,
                        driverId: driver.driver_id || "",  // Assign driverId if exists
                        driverName: driver.driver_name || "", // Assign driverName if exists
                    };
                });
    
                // Update the configurations and drivers states
                setConfigurations(vehicles);
                fetchDriversForEmirate();  // Set the list of available drivers
    
                console.log('Configuration Details:', configData);
            } else {
                console.error('Error fetching configuration details');
            }
        } catch (error) {
            console.error('Error occurred while fetching configuration:', error);
        }
    };
    
    const fetchDriversForEmirate = async () => {
        try {
            // Replace this API endpoint with the actual one that fetches drivers based on the emirate
            const response = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);
    
            if (response.data.success) {
                const driversData = response.data.data;  // The array of driver objects
    
                // Map the response to extract driverId and name
                const driversList = driversData.map(driver => ({
                    driver_id: driver.driverId,
                    driver_name: driver.name
                }));
    
                // Set the drivers state
                setDrivers(driversList);
            } else {
                console.error('Error fetching drivers for emirate:');
            }
        } catch (error) {
            console.error('Error fetching drivers:', error);
        }
    };
    

    // Handle Driver Change for a Vehicle
    const handleDriverChange = (vehicleId, newDriverId, isNewConfig = false) => {
        const updatedConfig = (isNewConfig ? configData : configurations).map((config) => {
            if (config.id === vehicleId) {
                const driver = drivers.find(driver => driver.driver_id === newDriverId);
                const driverName = driver ? driver.driver_name : 'Unknown'; // Set driver name or 'Unknown' if not found
                return { ...config, driverId: newDriverId, driverName };
            }
            return config;
        });
    
        if (isNewConfig) {
            setConfigData(updatedConfig); // Update new config data
        } else {
            setConfigurations(updatedConfig); // Update existing config data
        }
    };
    
    
    

  
    


    const handleUpdateDriver  = async (vehicleId, driverId) => {
        const selectedConfigId = newconfiguration ? null : selectedConfig; // Get the configuration ID if not new
        const vehicleToUpdate = (newconfiguration ? configData : configurations).find(vehicle => vehicle.id === vehicleId);
        const driver = drivers.find(driver => String(driver.driver_id) === String(driverId));
        console.log('drivers is ',drivers)
        const driverName=driver.driver_name



    // Step 3: Update the driver details in the vehicle in configurations
    vehicleToUpdate.driverId = driverId;
    vehicleToUpdate.driverName = driver.driver_name;

    // Step 4: Construct the updated configuration drivers array (including both updated and unchanged drivers)
    const updatedDrivers = configurations.map(vehicle => {
        if (vehicle.id === vehicleId) {
            // For the updated vehicle, use the updated driverId and driverName
            return {
                driver_id: vehicle.driverId,
                driver_name: vehicle.driverName
            };
        } else {
            // For other vehicles, leave them unchanged
            return {
                driver_id: vehicle.driverId,
                driver_name: vehicle.driverName
            };
        }
    });

    // Step 5: Prepare the API payload
    const apiPayload = {
        id: selectedConfigId, // The vehicle ID to update
        drivers: updatedDrivers // Include all drivers, updated and unchanged
    };

    // Log the API payload for debugging
    console.log('API Payload:', apiPayload);


        if (vehicleToUpdate) {

            try {
                const response = await axios.post(
                    `${API_URL}shypvdriverapp/configure/updateConfiguration`,
                    apiPayload,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );
        
                // Handle the response from the API
                if (response.data.success === true) {
                    console.log('Configuration updated successfully:', response.data);
                } else {
                    console.error('Failed to update configuration:', response.status);
                }
            } catch (error) {
                console.error('Error updating configuration:', error);
            }

            console.log(`Updating driver  ${driverId} for vehicle ${vehicleId} in configuration ${selectedConfigId}`);
            // API call to update the driver for the selected vehicle
            console.log('config is',configurations)
            console.log('newconfiguration is',newconfiguration)
        }
    };
    

    // Columns for DataTable
 

    const nextArrow={
        fontSize: '25px',
    fontWeight: '600',
    float: 'right'
}
    useEffect(() => {
    
       
    
        $(".btn-demo.import").on('click',function(){
            seterrormsg('')
                $('.nalier.middle-center.fade').css("display", "block");
                $('.nalier.middle-center.fade').addClass("in");
        });
    
        $(".close.h-close").on('click',function(){
                $('.nalier.middle-center.fade.in').css("display", "none");
                $('.nalier.middle-center.fade').removeClass("in");
        });
  
        
    
    }, []);
    const [selectedVehicle, setSelectedVehicle] = useState(""); // State for selected vehicle
    useEffect(() => {
        getVehicleModels();
    }, []);
    const [isload, setisload] = useState(true);
    const getVehicleModels = async () => {
        const API_PATH = `${API_URL}shypvdriverapp/vehicleModel/getModels`;
        
        try {
            const res = await axios.get(API_PATH);
            console.log(res.data);
            setVehicleModels(res.data.data);
            
            setisload(false);
        } catch (err) {
            console.log(err);
        }
    };

    const handleVehicleChange = (e) => {
        setSelectedVehicle(e.target.value);
    };
    const [configData, setConfigData] = useState([]);
const [newconfiguration, setnewconfiguration] = useState(false)
    

    const newConfig = () => {
        seterrormsg('')
        const rows = Array.from({ length: vehicleCount }, (_, index) => ({
            id: index + 1,
            vehicle: `Vehicle ${index + 1}`,
            driverId: "",         // Initially no driver is selected
            driverName: "",       // Initially no driver name is selected
        }));
    
        setConfigData(rows); // Update the state with new configuration rows
        fetchDrivers();
        setnewconfiguration(true);
        $('.nalier.middle-center.fade.in').css("display", "none");
        $('.nalier.middle-center.fade').removeClass("in");
    };
    


    // const handleDriverChange2 = (vehicleId, newDriverId) => { 
    //     // Alert to verify new driver ID
      
    
    //     // Update the configData state with the selected driver
    //     const updatedConfig = configData.map((config) => {
    //         if (config.id === vehicleId) {
    //             const driver = drivers.find(driver => driver.driver_id === newDriverId);
    //             const driverName = driver ? driver.driver_name : 'Unknown'; // Set driver name or 'Unknown' if not found
    //             return { ...config, driverId: newDriverId, driverName };
    //         }
    //         return config;
    //     });
    
    //     // Update the configuration state
    //     setConfigData(updatedConfig);
    // };

    

    const saveNewConfig = async () => {
        // Ensure we have selected a vehicle type and drivers
        seterrormsg('')
        console.log('selectedVehicle',selectedVehicle)
        console.log('configurations',configData)
        console.log('drivers',drivers)
        if (!selectedVehicle || configData.length === 0 || !drivers || drivers.length === 0) {
            alert("Please make sure all fields are filled out (vehicle type, driver assignments, etc.)");
            return;
        }
    
        // Prepare the drivers list based on selected configurations
        const selectedDrivers = configData.map(vehicle => ({
            driver_id: vehicle.driverId // Get driver_id for each vehicle
        }));
    
        // Prepare the request body
        const requestBody = {
            vehicle_count: vehicleCount, // Total count of vehicles
            vehicle_type: selectedVehicle, // The selected vehicle type
            configuration_name: newConfigName, // Configuration name (can be dynamic if required)
            updated_by: 1, // Assuming user id 1 for now, replace with actual user id if needed
            drivers: selectedDrivers, // List of drivers assigned to the vehicles
        };
    
        try {
            // API call to save the configuration
            const response = await axios.post(
                `${API_URL}shypvdriverapp/configure/saveConfiguration`,
                requestBody, 
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
    
            if (response.data.success) {
                alert("Configuration saved successfully!");
                fetchConfigurations()
                setnewconfiguration(false)
                // Optionally, you can clear the configuration data after saving
                // setConfigurations([]); // Clear configurations or reset state
            } else {
                alert("Failed to save configuration. Please try again.");
            }
        } catch (error) {
            console.error("Error occurred while saving configuration:", error);
            alert("An error occurred while saving the configuration.");
        }
    };
    
const [errormsg, seterrormsg] = useState('')
const [planmsg, setplanmsg] = useState('')
    const generatePlan = async () => {
        if(selectedConfig > 0){
        setplanmsg('loading...')
        const API_PATH = `${API_URL}shypvdriverapp/jobs/getOrdersByDateAndCode`;
    
        // Set the parameters to pass in the request
        // const params = {
        //     date: '2024-11-13',  // You can replace this with dynamic data if needed
        //     code: 'dxb'          // Same for emirate code
        // };

        const emirate = sessionStorage.getItem('selectedEmirate');
        const lowercaseEmirate = emirate ? emirate.toLowerCase() : '';
            // Set the parameters to pass in the request
            const params = {
                date: sessionStorage.getItem('selectedDate'),  // You can replace this with dynamic data if needed
                code: lowercaseEmirate          // Same for emirate code
            };
    
        try {
            // Perform GET request with query parameters
            const res = await axios.get(API_PATH, { params });
    
            // Check if the response is successful
            if (res.data.success) {
                const orders = res.data.data.orders;
                // setData(orders); // Update your state with the order list
                
                // Call generatePlan API with the configuration ID and the list of order IDs (AWB)
                if (orders.length > 0) {
                    // const orderIds = orders.map(order => order.awb); // Extract AWB (order ID)
                    const orderIds = orders
    .filter(order => order.awb !== 'careem-demo101')  // Exclude orders with awb 'careem-demo101'
    .map(order => order.awb);  // Extract the AWB (order ID)
                    generatePlanAPI(orderIds); // Call generatePlan with the extracted order IDs
                }
    
                setisload(false);  // Assuming this stops your loading indicator
            } else {
                
                console.error('Error fetching order list:', res.data.errors);
            }
        } catch (err) {
            console.error('Axios error:', err);
        }
    }
    else{
        seterrormsg('Please choose a configuration')
    }
    };

    const generatePlanAPI = async (orderIds) => {
        const API_PATH = `${API_URL}shypvdriverapp/configure/generatePlan`;
    
        // Create the request body for the generatePlan API
        const requestBody = {
          configuration_id: selectedConfig,  // Use the selectedConfig value
          order_ids: orderIds  // Pass the extracted list of order IDs
        };
    
        try {
          // Perform POST request to the generatePlan API
          const res = await axios.post(API_PATH, requestBody, {
            headers: {
              'Content-Type': 'application/json'
            }
          });
    
          // Check if the API call was successful
          if (res.data.success) {
            console.log('Generate Plan success:', res.data);
            setplanmsg('Plan generated. redirecting for dispatch...')
            await new Promise(resolve => setTimeout(resolve, 3200)); // 2 seconds
            // Redirect to the dispatch page and pass the response data as state
            navigate('/orders/dispatch', {
              state: {
                routes: res.data.data.routes,
                planId: res.data.data.plan_id
              }
            });
          } else {
            setplanmsg('plan generation failed')
            console.error('Generate Plan API Error:', res.data.errors);
          }
        } catch (err) {
            setplanmsg('plan generation failed')
          console.error('Error occurred while calling generatePlan:', err);
        }
      };

    // const generatePlanAPI1 = async (orderIds) => {
    //     const API_PATH = `${API_URL}shypvdriverapp/configure/generatePlan`;
    
    //     // Create the request body for the generatePlan API
    //     const requestBody = {
    //         configuration_id: selectedConfig,  // Use the selectedConfig value
    //         order_ids: orderIds  // Pass the extracted list of order IDs
    //     };
    
    //     try {
    //         // Perform POST request to the generatePlan API
    //         const res = await axios.post(API_PATH, requestBody, {
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             }
    //         });
    
    //         // Check if the API call was successful
    //         if (res.data.success) {
    //             console.log('Generate Plan success:', res.data);
    //             ViewPlan()
    //             // Handle success, e.g., show a success message or update UI
    //         } else {
    //             seterrormsg('Failed to generate plan. Please try again')
    //             console.error('Generate Plan API Error:', res.data.errors);
    //         }
    //     } catch (err) {
    //         seterrormsg('Failed to generate plan. Please try again')
    //         console.error('Error occurred while calling generatePlan:', err);
    //     }
    // };
    
    
    // function ViewPlan(){
    //     window.location.href='/orders/dispatch'
    // }
   
    // Function to go to the previous page
    const goPrev = () => {
      navigate(-1);  // -1 will take the user to the previous page in the history stack
    };
   
    return (
        <div className="wrapper-holder">
            <div className="main-panel ps-container">
                <div className="content">
                    <div className="container-fluid">
                    <div className="row">
                        <a className="prev" onClick={goPrev}> <i class="fa fa-arrow-circle-left prevarrow" aria-hidden="true"></i></a>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                              
                                <div className="card">
                                    <div className="card-header card-header-primary">
                                   
                                        <h4 className="card-title">Driver Location Configurations</h4>
                                    </div>
                                    <div className="card-body">
                                    <button type="button" className="btn-demo import" style={{ background: '#00a6ed', color: '#fff', padding: '3px', marginRight: '10px' }} data-toggle="modal" data-target="#myModal">Add New Conf</button>
                                        
                                        {/* Dropdown to select an existing configuration */}
                                        <select
                                            className="form-control"
                                            value={selectedConfig}
                                            onChange={handleConfigChange}
                                            style={{ display: 'inline-block', width: 'auto' }}
                                        >
                                            <option value="">Select Existing Conf.</option>
                                            {configurations2.length > 0 ? (
                    configurations2.map(config => (
                        <option key={config.configuration_id} value={config.configuration_id}>
                            {config.configuration_name}
                        </option>
                    ))
                ) : (
                    <option value="">Loading configurations...</option>
                )}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Display the selected configuration and allow driver change */}
            <div className="driver-list">
                {/* {selectedConfig && (
                    <h4>Selected Configuration: {existingConfigs.find(config => config.id === parseInt(selectedConfig))?.name}</h4>
                )} */}
{/* 
                <DataTableExtensions
                    columns={columns}
                    data={configurations}  // Only display data for the selected configuration
                >
                    <DataTable
                        columns={columns}
                        data={configurations}  // Only display data for the selected configuration
                        noHeader
                        defaultSortField="id"
                        pagination
                    />
                </DataTableExtensions> */}
            </div>

            
    <div className="mt-4 container-fluid" style={{marginTop:'4%'}}>
      
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th>Vehicle</th>
                    <th>Driver</th>
                </tr>
            </thead>
            <tbody>
    {(newconfiguration ? configData : configurations).map((vehicle) => (
        <tr key={vehicle.id}>
            <td>{vehicle.vehicle}</td>
            <td>
                <select
                    className="form-control"
                    value={vehicle.driverId} // Bind the dropdown value to the vehicle's driverId
                    onChange={(e) => handleDriverChange(vehicle.id, e.target.value, newconfiguration)} // Trigger the change handler on selection
                >
                    <option value="">Select Driver</option>
                    {isDriverLoading ? (
                        <option>Loading drivers...</option>
                    ) : (
                        drivers.map((driver) => (
                            <option key={driver.driver_id} value={driver.driver_id}>
                                {driver.driver_name}
                            </option>
                        ))
                    )}
                </select>
            </td>
            <td style={{ width: '80px' }}>
                <button
                    className="btn btn-link update-btn"
                    onClick={() => handleUpdateDriver(vehicle.id,vehicle.driverId)}
                    style={{ color: '#fff', border: 'none', outline: 'none',background:'#00a6ed' }}
                >
                    update <i className="fa fa-edit"></i>
                </button>
            </td>
        </tr>
    ))}
</tbody>

        </table>

       

                                        <div className="ActionsBar_right_ttCWs">
                                        
                                        {newconfiguration?(
 <a onClick={saveNewConfig}style={buttonsyle}>Save Config</a >
                                        ):(
                                            <a onClick={generatePlan} style={buttonsyle} type="button" className="btn-demo add">
                                            Generate Plan
                                        </a>
                                        )}
       
        </div>
<p>{planmsg}</p>

                                        {/* <a onClick={ViewPlan} style={buttonsyle} type="button" className="btn-demo add">
                                            Next
                                        </a> */}
                                        <p style={{color:'red'}}>{errormsg}</p>
    </div>






{/* {newconfiguration && configData.length > 0 && (
    <div className="mt-4">
       
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th>Vehicle</th>
                    <th>Driver</th>
                </tr>
            </thead>
            <tbody>
                {configData.map((vehicle) => (
                    <tr key={vehicle.id}>
                        <td>{vehicle.vehicle}</td>
                        <td>
                            <select
                                className="form-control"
                                value={vehicle.driverId} // Bind the dropdown value to the vehicle's driverId
                                onChange={(e) => handleDriverChange2(vehicle.id, e.target.value)} // Trigger the change handler on selection
                            >
                                <option value="">Select Driver</option>
                                {isDriverLoading ? (
                                    <option>Loading drivers...</option>
                                ) : (
                                    drivers.map((driver) => (
                                        <option key={driver.driver_id} value={driver.driver_id}>
                                            {driver.driver_name}
                                        </option>
                                    ))
                                )}
                            </select>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        
    </div>
)} */}




            <div className="nalier middle-center fade" id="myModal" role="dialog" aria-labelledby="myModalLabel" style={{display: "none"}}>
                    <div className="nalier-dialog" style={{height:'auto'}} role="document">
                        <div className="nalier-content">

                        <div className="nalier-header">
                            <button type="button" className="close h-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 className="nalier-title" id="myModalLabel">Add New Vehicle</h4>
                        </div>
                        <div className="nalier-body">
                        <div className="modal-gap">&nbsp;</div>


                        <div className="row" style={{ textAlign: "center", padding: "15px", margin: "15px" }} >
                                <div className="col-md-12">
                                  <div className="row">
                                  <div className="col-md-4">
                                    
                                    <input type="text" onChange={(e)=>setnewConfigName(e.target.value)} className="form-control" placeholder="Config Name" />
                            </div>
                                    <div className="col-md-4">
                                     
                                    <select className="form-control" value={selectedVehicle} onChange={handleVehicleChange} style={{ display: 'inline-block', width: 'auto' }}>
                                            <option value="">Vehicle Type</option>

                                            {vehicleModels && vehicleModels.length > 0 ? (
                                            vehicleModels.map((veh) => (
                                                <option key={veh.vehicle_model_code} value={veh.vehicle_model_name}>{veh.vehicle_model_name}</option>
                                            ))
                                        ) : null} 

                                           
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                    
                                            <input type="text" onChange={(e)=>setVehicleCount(e.target.value)} className="form-control" placeholder="count" />
                                    </div>
                                    
                                  </div>
                                
                                </div>
                              </div>
                              <div className="row">
                                  <div className="col-md-6"></div>
                                  <div className="col-md-5">
                                  <a onClick={newConfig}> <i style={nextArrow} className="fa fa-angle-double-right css-zfl09c" aria-hidden="true" /> </a>

                                </div>
                                </div>
                              </div>

                        </div>
                        </div>
                        </div>

        </div>
    );
}
